import {Modal} from '../../../ui-library';
import React from 'react';
import {ButtonsBox, LabelTitle, ModalBox, ModalTitle, StartBtn, NumOfImages, AutoAlert, ExitIcon, ClassChip, ClassesBox, ImagesIcon, ClassContainer} from '../Style/CreateAutoProjectConfirmation.style';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import {TextFieldVI} from '../../TextFieldVI';
import {InputType} from '../../../configuration/inputTypes/inputTypes.config';
import useCreateAutoProjectConfirmation from '../Controller/CreateAutoProjectConfirmation.controller';

const CreateAutoProjectConfirmationView = ({autoProjectState, handleSaveBtnClick, open, chosenTags, setState, isDisabled}) => {
    const {handleExitModal} = useCreateAutoProjectConfirmation(setState);

    return (
        <>
            <Modal
                open={open}>
                <>
                    <ModalBox>
                        <ExitIcon onClick={() => handleExitModal()}/>
                        <ModalTitle>{_SYSTEM_TITLES.createNewAutoProjectTitle}</ModalTitle>
                        <TextFieldVI helperTextValue={autoProjectState.showProjectNameError ? _SYSTEM_TITLES.autoProjectMandatoryNameAlert : ''} globalError={autoProjectState.nameExistError} getValue={(value) => setState({projectName: value, showProjectNameError: false})}
                            inputType={InputType.ProjectName} inputLabel={_SYSTEM_TITLES.autoProjectNameLabel}/>
                        <AutoAlert severity='warning'>{_SYSTEM_TITLES.autoProjectConfirmationWarning}</AutoAlert>
                        <LabelTitle>{_SYSTEM_TITLES.autoProjectConfirmationClassesTitle}</LabelTitle>
                        {chosenTags && <ClassesBox>
                            {chosenTags.map((tag) => (
                                <ClassContainer key={tag}>
                                    <ClassChip
                                        key={tag}
                                        label={autoProjectState.tags.find((curTag) => curTag.tag_id === tag).tag_name}/>
                                    <ImagesIcon/>
                                    <NumOfImages>
                                        {autoProjectState.classes[autoProjectState.classes.findIndex((item) => item.tag_id === tag)].imageList.length}
                                    </NumOfImages>
                                </ClassContainer>
                            ))}
                        </ClassesBox>}
                        <ButtonsBox>
                            <StartBtn disabled={isDisabled} variant='contained' size='large' onClick={handleSaveBtnClick}>{_SYSTEM_TITLES.autoProjectConfirmStartBtn}</StartBtn>
                        </ButtonsBox>
                    </ModalBox>
                </>
            </Modal>
        </>);
};

export default CreateAutoProjectConfirmationView;
